import { render, staticRenderFns } from "./BolUploadFile.vue?vue&type=template&id=90b456d2&scoped=true"
import script from "./BolUploadFile.vue?vue&type=script&lang=js"
export * from "./BolUploadFile.vue?vue&type=script&lang=js"
import style0 from "./BolUploadFile.vue?vue&type=style&index=0&id=90b456d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b456d2",
  null
  
)

export default component.exports